import React from 'react';
export const CurrencyFormatter = ({ amount = 0, locale = 'fr-FR', currency = 'EUR', minimumFractionDigits = undefined, withCurrencySymbol = true }) => {
    const options = {};
    if (withCurrencySymbol) {
        options.style = 'currency';
        options.currency = currency;
    }
    if (minimumFractionDigits !== undefined) {
        options.minimumFractionDigits = minimumFractionDigits;
        options.maximumFractionDigits = minimumFractionDigits;
    }
    else if (Number.isInteger(amount)) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
    }
    return (React.createElement("span", { "data-qa": "currency-formatter" }, new Intl.NumberFormat(locale, options).format(amount)));
};
